import * as ChangeProjectDataTypes from 'src/actions/project/change-data/Types';
import { ChangeProjectData, ChangeProjectDataAction } from 'src/actions/project/change-data/ChangeProjectData.actions';
import ProjectData from 'src/value-objects/ProjectData';

export interface ChangeProjectDataState {
  project?: ProjectData;
  loading: boolean;
}

const initialState: ChangeProjectDataState = {
  loading: false
};

export function ChangeProjectDataReducer(state: ChangeProjectDataState = initialState,
                                         action: ChangeProjectDataAction): ChangeProjectDataState {
  switch (action.type) {
    case ChangeProjectDataTypes.CHANGE_PROJECT_DATA:
      const project: ProjectData = (action as ChangeProjectData).payload;
      return {...state, project: project, loading: false};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project/ChangeProjectDataReducer.tsx